import { AppShell } from '../shared/ui/AppShell'
import { TopicListList } from '../features/topics/ui/TopicsList'
import { useTopicsController } from '../features/topics/state/useTopicsController'
import { ErrorState } from '../shared/ui/States'
import { TopicRowSkeleton } from '../features/topics/ui/TopicSkeleton'

export function TopicsPage() {
  const controller = useTopicsController()

  return (
    <AppShell showAnalytics={false}>
      <div className="mx-auto w-full max-w-[1000px] px-0 py-2 sm:px-6 sm:py-6">
        {controller.isLoading && (
          <div className="flex flex-col gap-4">
            {[...Array(3)].map((_, i) => (
              <TopicRowSkeleton key={i} />
            ))}
          </div>
        )}
        {controller.error && <ErrorState error={controller.error} />}

        {!controller.isLoading && !controller.error && (
          <TopicListList
            topicLists={controller.topicLists}
            total={controller.total}
            query={controller.query}
            onSearchChange={controller.onSearchChange}
            onPlatformChange={controller.onPlatformChange}
            onSortChange={controller.onSortChange}
            onPageChange={controller.onPageChange}
            onCreate={controller.createTopicList}
            onUpdate={controller.updateTopicList}
            onDelete={controller.deleteTopicList}
          />
        )}
      </div>
    </AppShell>
  )
}
